import { useState } from "react";
import { toN, mkMap, makeId, findIndexByName } from "../utils";
import { Card, ST, NI, BulkBtn, PastePanel } from "../ui/SharedUI";

export default function TransportEditor({staff, setStaff, months}) {
  const [editName, setEditName] = useState(null);
  const upd    = (id,m,val) => setStaff(prev=>prev.map(s=>s.id===id?{...s,transport:{...s.transport,[m]:val}}:s));
  const setAll = (id,val)   => setStaff(prev=>prev.map(s=>s.id===id?{...s,transport:mkMap(months,toN(val))}:s));
  const updName= (id,name)  => setStaff(prev=>prev.map(s=>s.id===id?{...s,name}:s));
  const add    = () => setStaff(prev=>[...prev,{id:makeId("staff"),name:"新規",salary:mkMap(months,0),bonus:mkMap(months,0),transport:mkMap(months,0)}]);
  return (
    <div style={{display:"flex",flexDirection:"column",gap:"16px"}}>
      <Card>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"12px"}}>
          <ST>交通費設定</ST>
          <button onClick={add} style={{padding:"6px 14px",background:"#2D7A2D",color:"#fff",border:"none",borderRadius:"4px",cursor:"pointer",fontSize:"12px",fontFamily:"'Noto Sans JP',sans-serif"}}>＋ 人員追加</button>
        </div>
        <p style={{fontSize:"11px",color:"#888",marginBottom:"16px",fontFamily:"'Noto Sans JP',sans-serif"}}>人員ごとの月次交通費を設定します。合計が「経費設定」に自動反映されます。</p>
        <PastePanel mode="person_row" onApply={(preview)=>{
          setStaff(prev => {
            const updated = [...prev];
            preview.rows.forEach((r, i) => {
              const idx = findIndexByName(updated, r.name, !r.name ? i : -1);
              const vals = Object.fromEntries(months.map((m,j)=>[m, r.values[j] ?? 0]));
              if (idx >= 0) { updated[idx] = {...updated[idx], transport: vals, name: r.name || updated[idx].name}; }
              else if (r.name) { updated.push({id:makeId("staff"),name:r.name,salary:mkMap(months,0),bonus:mkMap(months,0),transport:vals}); }
            });
            return updated;
          });
        }} months={months}/>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:"12px"}}>
            <thead><tr style={{borderBottom:"2px solid #E8EDE8"}}>
              <th style={{textAlign:"left",padding:"5px 8px",color:"#888",minWidth:"80px"}}>氏名</th>
              <th style={{textAlign:"center",padding:"5px 5px",color:"#888",width:"44px"}}>一括</th>
              {months.map(m=><th key={m} style={{textAlign:"right",padding:"5px 2px",color:"#888",minWidth:"66px"}}>{m}</th>)}
              <th style={{textAlign:"right",padding:"5px 8px",color:"#888",minWidth:"72px",position:"sticky",right:0,background:"#fff",boxShadow:"-2px 0 4px rgba(0,0,0,0.06)"}}>年計</th>
            </tr></thead>
            <tbody>
              {staff.map((s,si)=>(
                <tr key={s.id} style={{borderBottom:"1px solid #F0F4F0",background:si%2===0?"#FAFCFA":"#fff"}}>
                  <td style={{padding:"4px 8px"}}>
                    {editName===s.id
                      ? <input autoFocus value={s.name} onChange={e=>updName(s.id,e.target.value)} onBlur={()=>setEditName(null)} style={{width:"72px",border:"1px solid #2D7A2D",borderRadius:"3px",padding:"2px 4px",fontSize:"12px"}}/>
                      : <span onClick={()=>setEditName(s.id)} style={{cursor:"pointer",color:"#2D7A2D",textDecoration:"underline dotted",fontFamily:"'Noto Sans JP',sans-serif"}}>{s.name}</span>
                    }
                  </td>
                  <td style={{padding:"4px 5px",textAlign:"center"}}><BulkBtn onSet={val=>setAll(s.id,val)}/></td>
                  {months.map(m=><td key={m} style={{padding:"3px 1px",textAlign:"right"}}><NI value={s.transport[m]} onChange={val=>upd(s.id,m,val)} w="64px"/></td>)}
                  <td style={{padding:"4px 8px",textAlign:"right",fontFamily:"monospace",fontWeight:"700",color:"#1A3A1A",position:"sticky",right:0,background:si%2===0?"#FAFCFA":"#fff",boxShadow:"-2px 0 4px rgba(0,0,0,0.06)"}}>{months.reduce((sum,m)=>sum+toN(s.transport[m]),0).toLocaleString()}</td>
                </tr>
              ))}
              <tr style={{borderTop:"2px solid #E8EDE8",background:"#F5FAF5"}}>
                <td colSpan={2} style={{padding:"5px 8px",fontWeight:"700",color:"#2D7A2D",fontFamily:"'Noto Sans JP',sans-serif",fontSize:"12px"}}>月次合計</td>
                {months.map(m=><td key={m} style={{padding:"5px 2px",textAlign:"right",fontFamily:"monospace",fontWeight:"700",color:"#1A3A1A",fontSize:"12px"}}>{staff.reduce((s,p)=>s+toN(p.transport[m]),0).toLocaleString()}</td>)}
                <td style={{padding:"5px 8px",textAlign:"right",fontFamily:"monospace",fontWeight:"800",color:"#2D7A2D",fontSize:"13px",position:"sticky",right:0,background:"#F5FAF5",boxShadow:"-2px 0 4px rgba(0,0,0,0.06)"}}>{staff.reduce((s,p)=>s+months.reduce((ss,m)=>ss+toN(p.transport[m]),0),0).toLocaleString()}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
